import React, { useEffect, useState } from "react";
import { Col, ConfigProvider, Row, Table } from "antd";
import Input from "../../../../components/Input/Input";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import Text from "../../../../components/Text/Text";
import { FlexCol } from "../../../../components/Container/Container";
import { numberFormatter } from "../../../../utility/Formatter";
import Select from "../../../../components/Select/Select";
import Button from "../../../../components/Button/Button";
import { icon } from "../../../../resource";

export const DealerReportTab = () => {
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);
  const mockData = [
    {
      key: "1",
      shopName: "แคมเปญตัวอย่าง 1",
      totalPoints: 100,
      couponCount: `10 ใบ`,
      totalVolume: 100,
      shopList: [
        {
          shopId: 1,
          dateTime: "01/01/2024, 11.00",
          freebieName: "ของรางวัลตัวอย่าง",
          shopName: "ร้านตัวอย่าง 1",
          totalPoints: 50,
          totalVolume: 100,
        },
        {
          shopId: 2,
          dateTime: "01/01/2024, 11.00",
          freebieName: "ของรางวัลตัวอย่าง",
          shopName: "ร้านตัวอย่าง 2",
          totalPoints: 50,
          totalVolume: 100,
        },
      ],
    },
    {
      key: "2",
      shopName: "แคมเปญตัวอย่าง 2",
      totalPoints: 100,
      couponCount: `10 ใบ`,
      totalVolume: 100,
      shopList: [
        {
          shopId: 1,
          dateTime: "01/01/2024, 11.00",
          freebieName: "ของรางวัลตัวอย่าง",
          shopName: "ร้านตัวอย่าง 1",
          totalPoints: 50,
          totalVolume: 100,
        },
        {
          shopId: 2,
          dateTime: "01/01/2024, 11.00",
          freebieName: "ของรางวัลตัวอย่าง",
          shopName: "ร้านตัวอย่าง 2",
          totalPoints: 50,
          totalVolume: 100,
        },
      ],
    },
  ];

  const columns = [
    {
      title: "ร้าน Dealer ที่ตัดใช้",
      dataIndex: "shopName",
      key: "shopName",
      width: "45%",
    },
    {
      title: "จำนวนคูปอง",
      dataIndex: "couponCount",
      key: "couponCount",
    },
    {
      title: "แต้มรวม",
      dataIndex: "totalPoints",
      key: "totalPoints",
    },
    {
      title: "มูลค่ารวม",
      dataIndex: "totalVolume",
      key: "totalVolume",
    },
  ];

  return (
    <>
      <Row justify='start' gutter={16}>
        <Col span={6}>
          <Input autoComplete='off' placeholder='รหัสร้าน / ชื่อร้าน' suffix={<SearchOutlined />} />
        </Col>
        <Col span={3}>
          <Select data={[]} placeholder='เลือกเขต' />
        </Col>
        <Col span={12} />
        <Col>
          <Button
            title='ดาวน์โหลด'
            icon={<img src={icon.downloadFileIcon} style={{ width: 18, height: 18 }} />}
            typeButton='primary-light'
          />
        </Col>
      </Row>
      <br />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={mockData}
          scroll={{ x: "max-content" }}
          expandable={{
            expandedRowKeys,
            onExpandedRowsChange: (keys: any) => {
              setExpandedRowKeys(keys);
            },
            expandedRowRender: (record: any) => {
              return (
                <Table
                  columns={[
                    {
                      title: "วันที่ตัดใช้",
                      dataIndex: "dateTime",
                      key: "dateTime",
                      width: "15%",
                      render: (value: any, record: any) => <Text>{value}</Text>,
                    },
                    {
                      title: "ของรางวัล",
                      dataIndex: "freebieName",
                      key: "freebieName",
                      width: "32%",
                      render: (value: any, record: any) => (
                        <FlexCol>
                          <Text>{value}</Text>
                        </FlexCol>
                      ),
                    },
                    {
                      title: "ร้านค้าที่แลก (Sub-Dealer)",
                      dataIndex: "shopName",
                      key: "shopName",
                      width: "20%",
                      render: (value: any) => <Text>{value}</Text>,
                    },
                    {
                      title: "แต้มที่ใช้",
                      dataIndex: "totalPoint",
                      key: "totalPoint",
                      width: "16%",
                      render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                    },
                    {
                      title: "มูลค่า",
                      dataIndex: "totalVolume",
                      key: "totalVolume",
                      render: (value: any) => <Text>{numberFormatter(value, 2)}</Text>,
                    },
                  ]}
                  dataSource={record?.shopList}
                  pagination={false}
                  size='small'
                />
              );
            },
            expandIcon: ({
              expanded,
              onExpand,
              record,
            }: {
              expanded: boolean;
              onExpand: any;
              record: any;
            }) => {
              return expanded ? (
                <UpOutlined onClick={(event) => onExpand(record, event)} />
              ) : (
                <DownOutlined onClick={(event) => onExpand(record, event)} />
              );
            },
          }}
          pagination={{
            pageSize: 10,
            current: 1,
            total: 20,
            showSizeChanger: false,
            position: ["bottomCenter"],
            // onChange: (page) => {
            //   const nextPage = String(page);
            //   //setPage(nextPage);
            //   //setParams({ page: nextPage });
            // },
          }}
        />
      </ConfigProvider>
    </>
  );
};
